import {Component, OnInit} from '@angular/core';
import {DatePipe, DecimalPipe} from '@angular/common';
import {ApiService} from '../../../../../projects/accounting/src/public_api';
import {BsModalService} from 'ngx-bootstrap';

import {PendingDetailComponent} from './pending-detail/pending-detail.component';


@Component({
    selector: 'app-pending-ies',
    templateUrl: './pending-ies.component.html',
    styleUrls: ['./pending-ies.component.scss']
})
export class PendingIesComponent implements OnInit {

    loading = false;

    dtConfig = null;

    constructor(
        private date: DatePipe,
        private decimal: DecimalPipe,
        private api: ApiService,
        private bsModalService: BsModalService
    ) {

    }

    ngOnInit() {
        this.load();
    }

    load() {
        this.loading = true;
        this.api.pendingIEs({Mode: 'list'}).subscribe((rs: any) => {
            console.log(rs);
            this.loading = false;
            this.dtConfig = {
                data: rs.data.filter(i => i.Details.length > 0),
                txt: i => i,
                title: 'Đơn hàng cần xác nhận',

                group: i => {
                    return {parent: i.Type == 'import' ? 'Đơn nhập' : 'Đơn xuất', html: i.Partner.Name};
                },

                columns: [
                    {
                        title: 'Kho',
                        html: i => `<b>${i.Warehouse.Name}</b>`,
                    },
                    {
                      title: '',
                      html: i => `
                            <small class="${i.Type == 'import' ? 'text-warning' : 'text-danger'}">${i.Type === 'import' ? 'Đơn nhập' : 'Đơn xuất'}</small><br>
                            <b class="text-primary">${this.date.transform(i.Stamp, 'dd-MM-yyyy')}</b><br>
                            <b>${i.Partner.Name}</b><br><small>${i.Partner.Address}</small>

                      `,
                      class:'on-extra',
                      css: i=> 'on-extra',
                        click: i => this.view(i)
                    },
                    {
                        title: 'Nhà cung cấp',
                        class: 'extra',
                        html: i => `<b>${i.Partner.Name}</b><br><small>${i.Partner.Address}</small>`,
                        css: i=> 'extra'
                    },

                    {
                        title: 'Đơn hàng',
                        class: 'text-center extra',
                        css: i => 'text-center extra',
                        html: i => `<b>${i.ID}</b><br><small class="${i.Type == 'import' ? 'text-warning' : 'text-danger'}">${i.Type === 'import' ? 'Đơn nhập' : 'Đơn xuất'}</small>`,
                        click: i => this.view(i)
                    },
                    {
                        title: 'Thời gian',
                        css: i => 'text-primary extra',
                        class: 'extra',
                        html: i => `<b>${this.date.transform(i.Stamp, 'dd-MM-yyyy')}</b>`
                    },
                    {
                        title: 'Tổng tiền',
                        class: 'text-right',

                        html: i => this.decimal.transform(i.Total, '1.0-0', 'en-US'),
                        css: i => 'text-success text-right'
                    }
                ],
            };
        });

    }

    view(i) {
        this.bsModalService.show(PendingDetailComponent, {
            class: 'modal-lg',
            initialState: {
                data: i
            }
        }).content.send.subscribe( rs => {
            this.load();
        })
    }


}
